import React from "react";

import LocationSearchInput from "../../Places";
import Dropdown from "../../../Common/Dropdown";

const PostLoginHead = ({
  user,
  title,
  routeName,
  handleSelectAddress,
  handleFindRestaurants,
  onSubmitPlace
}) => (
  <div className="image-section">
    <div className="container">
      <div className="row">
        <div className="col-xs-6">
          <h4>
            Takeaway that supports <br/>
            local and earns rewards
          </h4>
        </div>
        <div className="col-xs-6">
          {(user.addresses && user.addresses.length && (
            <div className="form-group d-flex">
              <div>
                <label>Select from saved</label>
                {user && user.addresses && user.addresses.length && (
                  <Dropdown
                    list={user.addresses}
                    title={title || ""}
                    routeName={routeName || ""}
                    onSelectItem={handleSelectAddress}
                  />
                )}
              </div>

              <a
                href="javascript: void(0)"
                onClick={handleFindRestaurants}
                className="btn btn-blue"
              >
                <b>Find Restaurants</b>
              </a>
            </div>
          )) || <noscript />}
          <div className="new-location">
            <label>Enter your address</label>
            <LocationSearchInput
              className="form-input"
              placeholder="e.g. 39 Old Town"
              onSubmit={onSubmitPlace}
            />
            <button>
              <i className="icon icon-search-gray" />
            </button>
          </div>
        </div>
      </div>
      {/* .row */}
    </div>
    {/* .container */}
  </div>
);

export default PostLoginHead;
